import { resolveMediaUrl } from './mediaUrl';

export const BANNER_VARIANTS = Object.freeze({
  desktop: { width: 1920, height: 720, label: 'Desktop Preview' },
  laptop: { width: 1440, height: 540, label: 'Laptop Preview' },
  tablet: { width: 1024, height: 384, label: 'Tablet Preview' },
  mobile: { width: 768, height: 288, label: 'Mobile Preview' },
  thumb: { width: 400, height: 150, label: 'Thumbnail Preview' },
});

export const bannerImageUrl = (filename, variant = 'desktop') => {
  if (!filename) return '';
  if (filename.includes('/') || filename.includes('\\')) return '';
  if (!BANNER_VARIANTS[variant] && variant !== 'original') return '';
  return resolveMediaUrl(`/uploads/banners/${variant}/${encodeURIComponent(filename)}`);
};
